import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';
import { Card, Heading } from '@companion-professional/components';

interface SectionProps {
  // title is the title of the section.
  title?: string;

  // children are the components that are displayed in the section.
  children?: React.ReactNode;

  // className can be used to add additional classes to the section component.
  className?: string;
}

// Section is a white card that groups related content on a page.
export const Section: FunctionComponent<SectionProps> = ({ title, children, className }) => {
  return (
    <Card className={cn('justify-start p-4 md:p-6', className)}>
      {title ? (
        <Heading level="section" className="mb-4">
          {title}
        </Heading>
      ) : null}
      {children}
    </Card>
  );
};
